import { Component, Prop, Vue } from 'vue-property-decorator';
import { getMessages } from '@/helpers/DynamicMessages';
@Component({
    name: 'DynamicMessageGroup',
})
export default class default_1 extends Vue {
    @Prop()
    start;
    @Prop({ required: true })
    event;
    @Prop({ required: true })
    type;
    @Prop()
    quantities;
    get messages() {
        return getMessages(this.event, this.type, this.start, this.quantities);
    }
}
